import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').service('secondEmailService', secondEmailService);

    function secondEmailService(Shipper) {
        var secondEmails = [];

        Shipper.loggedInShipper(undefined, function (res) {
            if (!angular.isUndefined(res.contacts)) {
                map(res.contacts);
            }
        });

        function map(contacts) {
            for (var i = 0; i < contacts.length; i++) {
                var secondMail = build(
                    contacts[i].id,
                    contacts[i].type,
                    contacts[i].communication.email
                );
                secondEmails.push(secondMail);
            }
        }

        function build(id, type, mail) {
            return {
                id: id,
                enum: mapContactType(type),
                name: type + ' (' + mail + ')'
            };
        }

        function mapContactType(type: ContactType) {
            switch (type) {
                case 'OPERATION':
                    return 'OPERATIONS_DEPARTMENT';
                default:
                    return type;
            }
        }

        function toContactType(key: SecondEmailEnum) {
            switch (key) {
                case 'OPERATIONS_DEPARTMENT':
                    return 'OPERATIONS';
                default:
                    return key;
            }
        }

        function getSecondEmailObjectById(id) {
            if (angular.isUndefined(secondEmails) || !secondEmails) {
                return null;
            } else {
                var result = secondEmails.filter(function (item) {
                    return item.id == id;
                });
                return result[0];
            }
        }

        return {
            secondEmails: secondEmails,
            getSecondEmailObjectById: getSecondEmailObjectById,
            mapContactType: mapContactType,
            toContactType: toContactType
        };
    }
})();
